import { OLAP_TOUR_TARGETS as T } from '@/components/olapV2/tour/olapTourTargets';
import i18n from '@/plugins/i18n';


// Guided-tour steps for the metrics-by-date chart block (WP-975) — the deep-dive companion to
// the two overview chart steps of the platform tour (steps/olap.js). Anchored to elements
// inside MetricsByDatePanel (plus the shared subrange slider and configs strip), so the same
// tour runs on every page that renders the chart; a step whose anchor is absent in the current
// state (no segmentation options, no product row charted, empty chart) is dropped by
// OlapTour.vue at open time.
//
// title/description are pulled from the locale files under `tour.olapChart.*` and exposed as
// getters so each read resolves against the active language — see steps/olap.js for the
// rationale.
const t = (key) => i18n.global.t(key);

export const olapChartTourSteps = [
  {
    key: 'intro',
    target: T.chart,
    placement: 'top',
    get title() { return t('tour.olapChart.intro.title'); },
    get description() { return t('tour.olapChart.intro.description'); },
  },
  {
    key: 'slots',
    target: T.chartMetrics,
    placement: 'bottom',
    get title() { return t('tour.olapChart.slots.title'); },
    get description() { return t('tour.olapChart.slots.description'); },
  },
  {
    key: 'types',
    target: T.chartMetricCard,
    placement: 'bottom',
    get title() { return t('tour.olapChart.types.title'); },
    get description() { return t('tour.olapChart.types.description'); },
  },
  {
    key: 'ma',
    target: T.chartMetricMa,
    placement: 'bottom',
    get title() { return t('tour.olapChart.ma.title'); },
    get description() { return t('tour.olapChart.ma.description'); },
  },
  {
    key: 'hover',
    target: T.chartCanvas,
    placement: 'top',
    get title() { return t('tour.olapChart.hover.title'); },
    get description() { return t('tour.olapChart.hover.description'); },
  },
  {
    key: 'segments',
    target: T.chartSegmentation,
    placement: 'bottom',
    get title() { return t('tour.olapChart.segments.title'); },
    get description() { return t('tour.olapChart.segments.description'); },
  },
  {
    key: 'entity',
    target: T.chartHeader,
    placement: 'bottom',
    get title() { return t('tour.olapChart.entity.title'); },
    get description() { return t('tour.olapChart.entity.description'); },
  },
  {
    key: 'product',
    target: T.chartProductChanges,
    placement: 'bottom',
    get title() { return t('tour.olapChart.product.title'); },
    get description() { return t('tour.olapChart.product.description'); },
  },
  {
    key: 'subrange',
    target: T.subrange,
    placement: 'top',
    get title() { return t('tour.olapChart.subrange.title'); },
    get description() { return t('tour.olapChart.subrange.description'); },
  },
  {
    key: 'save',
    target: T.configs,
    placement: 'bottom',
    get title() { return t('tour.olapChart.save.title'); },
    get description() { return t('tour.olapChart.save.description'); },
  },
];
